// extracted by mini-css-extract-plugin
export var avatar = "_m0-3";
export var avatarContainer = "_m0-2";
export var avatarSpacer = "_m0-5";
export var avatarSpacerContainer = "_m0-4";
export var avatarStackContainer = "_m0-1";
export var bubble = "_m0-0";
export var remainderBubble = "_m0-6";